<template>
    <van-popup
        v-model="show"
        closeable
        class="minisite-modal-popup"
        :close-on-click-overlay="false"
        :style="popupStyle"
        :overlay-style="overlayStyle"
        get-container="body"
        @click-close-icon="closeModal">
        <div class="minisite-modal-content" :style="getWrapperStyle">
            <basic-text :data="data.contents[0].text.contents" :font-style="data.style.fontStyle"></basic-text>
            <div class="minisite-modal-button" :style="data.style.buttonStyle" @click="handleConfirmClick">
                {{ data.style.buttonStyle.text }}
            </div>
        </div>
    </van-popup>
</template>

<script>
    import Vue from "vue"
    import { Popup } from "vant"
    import commonMixIn from "./../common.mixin"
    import { BasicText } from "./../basic/index"
    import { getStorage, setStorage } from "../../utils/storage"
    import { collect, ElementType } from "../../service/site"

    Vue.use(Popup)

    export default {
        name: "Template00",
        components: {
            BasicText
        },
        mixins: [commonMixIn],
        props: {
            data: {}
        },
        data() {
            return {
                show: false,
                showTimer: null
            }
        },
        computed: {
            popupStyle() {
                return {
                    width: "315px",
                    borderRadius: "6px",
                    overflow: "visible"
                }
            },
            overlayStyle() {
                return {
                    zIndex: 1000,
                    background: "rgba(0,0,0,0.45)"
                }
            },
            modalStorageKey() {
                if (this.data.settings && this.data.settings.scope === "site") {
                    return `MinisiteModal_${this._siteId}_${this.data.id}`
                }
                return `MinisiteModal_${this._siteId}_${this._pageId}_${this.data.id}`
            },
            getWrapperStyle() {
                if (this.data && this.data.style && this.data.style.listStyle) {
                    return Object.assign({}, this.data.style.listStyle, this.data.style.listStyle.background, {
                        ...this.getPadding(this.data.style.listStyle.padding),
                        borderRadius: this.data.style.listStyle.borderRadius + "px"
                    })
                }
                return {}
            }
        },
        mounted() {
            if (!this.shouldShowModal()) {
                return
            }

            const delaySeconds = Number(this.data.settings && this.data.settings.delaySeconds) || 0
            this.showTimer = window.setTimeout(() => {
                this.show = true
            }, delaySeconds * 1000)
        },
        beforeDestroy() {
            if (this.showTimer) {
                window.clearTimeout(this.showTimer)
            }
        },
        methods: {
            shouldShowModal() {
                if (this.data.settings && this.data.settings.frequency === "once") {
                    return !getStorage(this.modalStorageKey)
                }
                return true
            },
            closeModal() {
                this.show = false
                if (this.data.settings && this.data.settings.frequency === "once") {
                    setStorage(this.modalStorageKey, {
                        closed: true,
                        at: Date.now()
                    })
                }
            },
            async handleConfirmClick() {
                try {
                    await collect("MINISITE_SYSTEM_CLICK_MODAL_CONFIRM", {
                        s_elementType: ElementType.modal,
                        s_modalId: this.data.id
                    })
                } catch (e) {
                    console.error(e)
                }

                this.closeModal()
            }
        }
    }
</script>

<style lang="less">
    .minisite-modal-popup {
        z-index: 1000 !important;

        .van-popup__close-icon {
            z-index: 2;
        }
    }
</style>

<style lang="less" scoped>
    .minisite-modal-content {
        position: relative;

        img {
            max-width: 100%;
            height: auto;
        }

        .image_resized {
            width: initial;
            display: flex;
            margin: 0;
        }

        figure {
            &.image {
                text-align: center;
                margin: 0;

                img {
                    max-width: 100%;
                }
            }
        }

        .minisite-modal-button {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            padding: 8px 10px;
            border-radius: 50px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
    }
</style>
